import axios from '../common/axios';

// 获取图形验证码的图片
export const getCaptchaImage = () => axios.get('/user/captcha/image');
// 发送短信验证码
export const sendCaptcha = ({ phone, captcha, nonce }) => axios.post('/user/captcha', { phone, captcha, nonce });
// 登录
export const login = ({ phone, captcha, nonce }) =>
  axios.post('/thirdparty/consultant/login', { phone, captcha, nonce });
